export default __webpack_public_path__ + "455953eeacfc2a5977c3ea41a9832a28.png";